import styled from 'styled-components';
import C from '@assets/themes/colors';

export const Root = styled.div`
`

export const Bottom = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  margin: 8px 0px;
`;

export const EyeDropperContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  margin: 0px 10px;
  cursor: pointer;
`;